import {ON_BRANCHES_LIST} from '../constants/ActionTypes';

const INIT_STATE = {
    branchesList: []
};


export default (state=INIT_STATE,action) => {
    switch (action.type){

        case ON_BRANCHES_LIST: {
            return {...state, branchesList: action.payload};
        }
        default:
            return state;
    }
}